import { useRouter } from 'next/router'

const LangSwitcher = () => {
  const router = useRouter()
  const { locale, asPath } = router
  const nextLocale = locale === 'en' ? 'ru' : 'en'

  const handleChangeLocale = () => {
    let newUrl
    

    if (nextLocale === 'ru') {
      newUrl = asPath.replace(/^\/en(\/|$)/, '/')
    } else {
      newUrl = `/en${asPath.startsWith('/en') ? asPath.slice(3) : asPath}`
    }

    window.location.href = newUrl
  }

  return (
    <button
      onClick={handleChangeLocale}
      className="text-[1.4rem] xl:text-[1.6rem] text-1 cursor-pointer group  "
    >
      <span className={`${locale === 'en' ? 'text-white' : 'text-white-40 transition-colors  duration-300 group-hover:text-dusty-pink'} `}>EN</span>
      <span>/</span>
      <span className={`${locale === 'ru' ? 'text-white' : 'text-white-40 transition-colors  duration-300 group-hover:text-dusty-pink'} `}>RU</span>
    </button>
  )
}

export default LangSwitcher
